import * as types from '../constants/actionTypes';

import weatherApi from '../api/weatherApi';

export function findCityId(query) {
    return {
        promise: weatherApi.findCityId(query),
        type: types.FIND_WEATHER_CITY_ID
    };
}

export function getWeatherByCityId(id, units) {
    return {
        promise: weatherApi.getWeatherByCityId(id, units),
        type: types.FETCH_WEATHER_BY_CITY_ID
    };
}


// WEBPACK FOOTER //
// ./src/actions/weatherActions.js